var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHelpfulVideosIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 85,
    viewBox: "0 0 86 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.9693 0H8.61554C3.86558 0 0 4.00109 0 8.91509V76.0849C0 80.9989 3.86558 85 8.61554 85H56.2649C57.2491 85 58.0479 84.2012 58.0479 83.217C58.0479 82.2328 57.2491 81.434 56.2649 81.434H8.61554C5.8269 81.434 3.56603 79.0376 3.56603 76.0849V22.8939H82.0188V76.0849C82.0188 79.0376 79.7508 81.434 76.9693 81.434H70.0369C69.0527 81.434 68.2539 82.2328 68.2539 83.217C68.2539 84.2012 69.0527 85 70.0369 85H76.9693C81.7193 85 85.5848 80.9989 85.5848 76.0849V8.91509C85.5848 4.00109 81.7193 0 76.9693 0ZM57.0851 19.3279L49.6107 3.56603H63.3185L70.7929 19.3279H57.0851ZM39.6757 19.3279L32.2013 3.56603H45.9091L53.3835 19.3279H39.6757ZM22.2663 19.3279L14.7919 3.56603H28.4997L35.9742 19.3279H22.2663ZM3.56603 8.91509C3.56603 5.96241 5.83403 3.56603 8.61554 3.56603H11.0904L18.5648 19.3279H3.56603V8.91509ZM74.4945 19.3279L67.0201 3.56603H76.9693C79.7579 3.56603 82.0188 5.96241 82.0188 8.91509V19.3279H74.4945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3578 69.5876C37.1153 69.5876 36.8728 69.5377 36.6446 69.4379C35.9956 69.1526 35.5819 68.5107 35.5819 67.8046V35.8957C35.5819 35.1897 36.0027 34.5478 36.6446 34.2625C37.2936 33.9772 38.0496 34.1056 38.5702 34.5834L55.9511 50.5379C56.322 50.8731 56.5288 51.3509 56.5288 51.8502C56.5288 52.3494 56.322 52.8273 55.9511 53.1625L38.5702 69.1169C38.235 69.4236 37.8 69.5876 37.3649 69.5876H37.3578ZM39.1408 39.9539V63.7465L52.0998 51.8502L39.1408 39.9539Z",
    fill: "#FF7900"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 85.5848,
    height: 85,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpfulVideosIcon);
export default __webpack_public_path__ + "static/media/helpful_videos_icon.9ef118a9e366578a8497d0155cd44217.svg";
export { ForwardRef as ReactComponent };